import { h } from 'preact'; /** @jsx h */

import './ImageSwiper.scss';

import { register } from 'swiper/element/bundle';
register();

const ImageSwiper = ({ images }) => {
    return (
        <swiper-container className="image-swiper" loop="true" navigation="true" pagination="true">
            {images.length > 0 &&
                images.map(image => {
                    return (
                        <swiper-slide className="swiper-slide" key={image.src}>
                            <figure className="swiper-figure">
                                <img
                                    className="swiper-image"
                                    src={image.src}
                                    alt={image.alt}
                                    loading="lazy"
                                />
                                <figcaption className="swiper-caption">{image.caption}</figcaption>
                            </figure>
                        </swiper-slide>
                    );
                })}
        </swiper-container>
    );
};

export default ImageSwiper;
